window.angular
  .module("backend.jsData", ["js-data"])
  .config([
    "$httpProvider",
    function($httpProvider) {
      $httpProvider.interceptors.push("backend.config");
    }
  ])
  .run([
    "DS",
    function(DS) {
      DS.registerAdapter("cache", new DSLocalForageAdapter());
    }
  ])
  .provider("api", require("./api"))
  .provider("backend.config", require("./interceptor"))
  .factory("backend.Timesheet", require("./api/timesheet"))
  .factory("backend.Approval", require("./api/approval"))
  .factory("backend.News", require("./api/news"))
  .factory("backend.Content", require("./api/content"))
  .factory("backend.Projects", require("./api/projects"))
  .factory("backend.Payroll", require("./api/payroll"))
  .factory("backend.Leave", require("./api/leave"))
  .factory("backend.AppConfig", require("./api/config"))
  .config(require("./config"));



// WEBPACK FOOTER //
// ./src/api/js-data/index.js